module.exports = {
    DOWN: 40,
    ESCAPE: 27,
    LEFT: 37,
    RIGHT: 39,
    TAB: 9,
    UP: 38
};



// WEBPACK FOOTER //
// ./app/scripts/constants/keyboard.js